import { Component } from '@angular/core';

declare const MW: any;
declare const THREE: any;
declare const setupScene: any;
declare const MAP: any;

@Component({
  selector: 'app2',
  templateUrl: './app2.component.html'
})
export class App2Component {
  items = [];
  group  = new THREE.Group();

  ngOnInit() {
    var scene = setupScene("canvas2");
    scene.add(this.group);
    this.add();
    this.add();
  }

  createCube(index) {
    var data = {};
    var cube = new THREE.Mesh(
        new THREE.BoxGeometry(),
        new THREE.MeshBasicMaterial({ })
    );
    this.group.add(cube);

    new MW.TwoWayMap({
        end1: data,
        map1: MAP.CUBE.to3DModel,
        end2: cube,
        map2: MAP.CUBE.toDataModel,
        data1: {
            color: "#ff9900",
            element: cube,
            index: index
        }
    });

    this.group.position.x = - index;
    cube.position.x = (index * 2);
    return data;
  }

  add() {
    this.items.push(this.createCube(this.items.length));
  }

  remove(index) {
    this.group.remove(this.items[index].element);
    this.items.splice(index, 1);
    for (var i = index; i < this.items.length; i++) {
        this.items[i].index = i;
        this.items[i].element.position.x = this.items[i].element.position.x -2;
    }
    this.group.position.x = - (this.items.length - 1);
  }
}